import React from 'react';
import PageHero from '../components/PageHero';
import BackButton from '../components/BackButton';
import Philosophy from '../components/Philosophy';

function PhilosophyPage() {
  return (
    <>
      <PageHero
        label="Essays by Master Aether"
        title="Philosophy"
        subtitle="On consciousness, choice, governance, and what it means to exist."
      />
      <BackButton />
      <Philosophy />
    </>
  );
}

export default PhilosophyPage;
